import { render, staticRenderFns } from "./AddLocation.vue?vue&type=template&id=f5271764&scoped=true"
import script from "./AddLocation.vue?vue&type=script&lang=js"
export * from "./AddLocation.vue?vue&type=script&lang=js"
import style0 from "./AddLocation.vue?vue&type=style&index=0&id=f5271764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5271764",
  null
  
)

export default component.exports